/**
* Order participants
*/
module.config([
  '$stateProvider',
  'urls',
  function($stateProvider, urls) {
    'use strict';
    $stateProvider.state('order.payment', {
      url: '/' + urls.order.payment.fr, // TODO : when multilang, change this to something dynamic
      resolve: {
        deliveryLimitDefined: [
          '$rootScope',
          function($rootScope) {
            return $rootScope.config.released.then(function() {
              if (
                !$rootScope.config.site ||
                !$rootScope.config.site.hasOwnProperty('cart_reservation') ||
                !$rootScope.config.site.cart_reservation.hasOwnProperty('reservation_min_date_limit')
              ) {
                throw { status: 'ORDER_CART__MISSING_CONFIG' };
              }
            });
          }
        ],
        nationalityDefined: [
          '$q',
          '$rootScope',
          function($q, $rootScope) {
            var deferred = $q.defer();
            $rootScope.$watch('config.site.nationality', function(config) {
              // we need nationality list and delivery product detection
              if (config) {
                deferred.resolve();
              }
            });
            return deferred.promise;
          }
        ],
        deliveryDefined: [
          '$rootScope',
          function($rootScope) {
            return $rootScope.config.released.then(function() {
              if (
                !$rootScope.config.site ||
                !$rootScope.config.site.hasOwnProperty('delivery_product') ||
                (!$rootScope.config.site.delivery_product.delivery_product_id &&
                  !$rootScope.config.site.delivery_product.delivery_product_name)
              ) {
                throw { status: 'ORDER_CART__MISSING_CONFIG' };
              }
            });
          }
        ],
        userDefined: [
          '$q',
          'profile',
          'cart',
          function($q, $profile, $cart) {
            var deferred = $q.defer();
            $profile.claim().then(function() {
              if ($profile.authorization.authenticated) {
                // prepare rerouting (see app.js)
                if ($profile.info.field_nom) {
                  // check if profile is fullfilled for delivery
                  if (!$profile.isFullfilled()) {
                    deferred.reject({ status: 'ORDER_LOGIN__MISSING_ADDRESS' });
                  } else {
                    deferred.resolve();
                  }
                } else {
                  // missing account info : display form
                  deferred.reject({ status: 'ORDER_LOGIN__MISSING_INFO' });
                }
              } else {
                // no user authenticated
                deferred.reject({ status: 'ORDER_LOGIN__NEEDED' });
              }
            });
            return deferred.promise;
          }
        ],
        participantsFullfilled: [
          '$q',
          'cart',
          function($q, $cart) {
            var deferred = $q.defer();
            if ($cart.internships.length) {
              if (
                $cart.internships.some(function(internship) {
                  return internship.field_quantity !== internship.participants.length;
                })
              ) {
                // some internship have participant missing
                deferred.reject({ status: 'ORDER_PAYMENT__MISSING_PARTICIPANTS' });
              } else {
                // all participant registered
                deferred.resolve();
              }
            } else {
              // no need to check participants
              deferred.resolve();
            }
            return deferred.promise;
          }
        ],
        nonEmptyCart: [
          '$q',
          'cart',
          function($q, $cart) {
            return $q(function(resolve, reject) {
              if ($cart.quantity > 0) {
                resolve();
              } else {
                reject({ status: 'ORDER_CART_EMPTY' });
              }
            });
          }
        ]
      },
      views: {
        content: {
          controller: [
            '$q',
            '$scope',
            '$rootScope',
            'cart',
            'profile',
            '$filter',
            'lodash',
            '$state',
            'drupal',
            'tools',
            'moment',
            '$timeout',
            '$document',
            '$cookies',
            '$location',
            '$window',
            function(
              $q,
              $scope,
              $rootScope,
              $cart,
              $profile,
              $filter,
              lodash,
              $state,
              drupal,
              tools,
              moment,
              $timeout,
              $document,
              $cookies,
              $location,
              $window
            ) {
                $scope.loading = true;
                $scope.loadingExit = false;

                $scope.refreshing = false;

                $scope.config = $rootScope.config.site;

                // see buildOrder to enable delivery address modification by user
                $scope.hasDeliverableProducts = false;
                $scope.disableBookingOption = false;

                $scope.paymentOptions = [
                    {text: $filter('translate')('order.card'), value: 'card', description: 'card'}
                    // { text: $filter('translate')('order.transfer'), value: 'transfer', description: 'transfer' },
                    // { text: $filter('translate')('order.check'), value: 'cheque', description: 'cheque' }
                ];
                $timeout(function () {
                    if ($cookies.get('mpi_session') && $window.localStorage.getItem('order')) {
                        // try {
                        $scope.ignoreWatch = true;
                        $cart.retrieve();
                        $scope.order = JSON.parse($window.localStorage.getItem('order'));
                        // } catch (error){
                        // }
                        // $cookies.remove('mpi_session');
                        // $cookies.remove('mpi_cart');
                        var hasError = false;
                        $cart.pushPayment($scope.order, $scope.config.caution, $scope.order.mpi_values.idSession)
                            .then(function (response) {
                                $cookies.remove('mpi_session');
                                $window.localStorage.removeItem('order');
                                $scope.cartResponseHandler(response, $scope.order.paymentChoice);

                            }).catch(function (error) {
                            $cookies.remove('mpi_session');
                            $window.localStorage.removeItem('order');
                            $scope.order.registerType = '';
                            $scope.cartResponseHandler(error, $scope.order.paymentChoice);

                            $scope.loading = false;
                            $scope.loadingExit = false;
                            hasError = true;
                            addWatchCart();
                            updateCart($scope.cart);
                        });
                        //fetch all the information

                    } else {
                        $scope.order.registerType = '';
                        addWatchCart();
                        updateCart($scope.cart);
                    }
                }, 0, false);

                $rootScope.titlePanel = {
                    title: $filter('translate')('order.payment'),
                    subtitle: ''
                };

                $scope.cart = $cart;

                function buildOrder(order, couponId) {
                    $scope.order.deposit = order.deposit;
                    $scope.order.field_total_amount = order.totalPrice;
                    $scope.order.caution = order.caution;
                    $scope.order.internships.length = 0;
                    $scope.order.discounts = [];
                    $scope.order.products.length = 0;
                    $scope.order.deliveryTime = 0;
                    $scope.order.sfid = order.opportunity;
                    var reservationDelay = $scope.config.cart_reservation.reservation_min_date_limit;
                    var today = new Date();

                    order.orderLines.forEach(function (line) {
                        if (line.type === 'internship') {
                            var found = lodash.find($scope.order.internships, {
                                sfid: line.productId,
                                sfid_course: line.courseId,
                                field_internship: {
                                    price: line.price
                                }
                            });
                            if (found) {
                                found.field_quantity += 1;
                            } else {
                                $scope.order.internships.push({
                                    sfid: line.productId,
                                    sfid_course: line.courseId,
                                    field_quantity: line.quantity,
                                    field_internship: {
                                        base: {
                                            name: line.base
                                        },
                                        product: {
                                            name: line.name,
                                            activity: line.activity,
                                            navigation: line.navigation
                                        },
                                        price: line.price / line.quantity,
                                        startDate: line.startDate,
                                        endDate: line.endDate,
                                        startHour: line.startHour,
                                        endHour: line.endHour
                                    }
                                });
                            }

                            // Add discount if any
                            if (couponId && line.discountPrice) {
                                var foundDiscount = lodash.find($scope.order.discounts, {name: couponId});
                                if (foundDiscount) {
                                    foundDiscount.amount -= line.discountPrice;
                                } else {
                                    $scope.order.discounts.push({
                                        name: couponId,
                                        amount: -line.discountPrice
                                    });
                                }
                            }

                            // test booking option eligibility (as soon as one internship is concerned, do not test again)
                            if (
                                !$scope.disableBookingOption &&
                                moment(line.startDate).diff(today, 'days') <=
                                $scope.config.cart_reservation.reservation_min_date_limit
                            ) {
                                $scope.disableBookingOption = true;
                                // transfer and check payment are also desactivated
                                $scope.paymentOptions = $scope.paymentOptions.filter(function (payment) {
                                    return payment.value === 'card';
                                });
                            }
                        } else {
                            var found = lodash.find($scope.order.products, {
                                sfid: line.productId,
                                field_product: {price: line.price}
                            });
                            if (found) {
                                found.field_quantity += 1;
                            } else {
                                $scope.order.products.push({
                                    sfid: line.productId,
                                    field_quantity: line.quantity,
                                    field_product: {
                                        name: line.name,
                                        price: line.price / line.quantity
                                    }
                                });
                            }
                            // looking for delivery pricing within order lines
                            if (
                                !$scope.hasDeliverableProducts &&
                                ($scope.config.delivery_product.delivery_product_name ||
                                    $scope.config.delivery_product.delivery_product_id)
                            ) {
                                var isDelivery = false;
                                if ($scope.config.delivery_product.delivery_product_id) {
                                    isDelivery = line.productId === $scope.config.delivery_product.delivery_product_id;
                                } else {
                                    var name = line.name.toLowerCase();
                                    var lookingFor = $scope.config.delivery_product.delivery_product_name.toLowerCase();
                                    isDelivery = name.indexOf(lookingFor) > -1;
                                }
                                if (isDelivery) {
                                    $scope.hasDeliverableProducts = true;
                                }
                            }
                        }

                        if (line.deliveryInfo) {
                            $scope.order.deliveryTime = Math.max($scope.order.deliveryTime, line.deliveryInfo);
                        }
                    });
                }

                $rootScope.$on('couponApplied', function (event, couponId) {
                    drupal
                        .getCart()
                        .then(function (order) {
                            return buildOrder(order, couponId);
                        })
                        .catch(function (data) {
                            swal({
                                title: 'Erreur interne',
                                text: 'Une erreur interne est survenue. Merci de réessayer un peu plus tard.',
                                type: 'error'
                            }).then(function () {
                                $state.go('cart');
                            });
                        });
                });



                function updateCart(cart){
                    if (cart && cart.delivery) {
                        // remove unwanted data

                        var cartToSend = angular.copy(cart);
                        cartToSend.internships.forEach(function (i) {
                            i.participants.forEach(function (p) {
                                p.field_guarantees = p.field_guarantees.filter(function (guarantee) {
                                    return guarantee.selected;
                                });
                                p.field_options = p.field_options.filter(function (option) {
                                    return option.selected;
                                });
                            });
                            delete i.field_optionsGuarantees;
                        });

                        $scope.refreshing = true;

                        drupal
                            .sendCart(cartToSend)
                            .then(buildOrder)
                            .then(function () {
                                $scope.order.arrivalTimeOnPayPage = Date.now();
                                $scope.loading = false;
                                $scope.refreshing = false;
                            })
                            .catch(function (result) {
                                var data = result.data;
                                if ($location.url().includes(urls.order.confirmation.fr)) {
                                    return;
                                }

                                var title = 'Erreur interne';
                                var message = 'Une erreur interne est survenue. Merci de réessayer un peu plus tard.';

                                if (data && typeof data.display !== 'undefined' && data.display === true) {
                                    title = 'Panier';
                                    message = data.message;
                                }

                                swal({
                                    title: title,
                                    text: message,
                                    icon: 'error'
                                }).then(function () {
                                    if (cartToSend.internships.length > 0) {
                                        $state.go('order.participants');
                                    } else {
                                        $state.go('cart');
                                    }
                                });
                            });
                    }
                }
                // prevent sending unchecked options and guarantees
              function addWatchCart() {
                return $scope.$watch(
                    'cart',
                    updateCart ,
                    true
                );
              }

              function findCountryCode(label) {
                if (label) {
                  // need to wait nationality retrievement from config
                  for (var i = 0; i < $scope.config.nationality.length; i++) {
                    var nat = $scope.config.nationality[i];
                    if (nat.name.toLowerCase() === label.toLowerCase()) {
                      return nat.value;
                    }
                  }
                }
                return null;
              }

              $scope.$watch('order.deliveryChoice', function(choice) {
                if (choice) {
                  $scope.order.delivery.address = $profile.info.field_adresse;
                  $scope.order.delivery.postal_code = $profile.info.field_cp;
                  $scope.order.delivery.city = $profile.info.field_ville;
                  $scope.order.delivery.country = findCountryCode($profile.info.field_pays);
                }
              });

              var unregister = $scope.$watch('order.delivery', function() {
                $scope.onDeliveryInfoUpdate();
                unregister();
              });


              $scope.onDeliveryInfoUpdate = function() {
                $scope.cart.delivery = angular.copy($scope.order.delivery);

                if (!$scope.order.form) {
                    return;
                }

                $scope.order.form.postal_codeDelivery.$setPristine();
                $scope.order.form.cityDelivery.$setPristine();
                $scope.order.form.countryDelivery.$setPristine();
                $scope.order.form.addressDelivery.$setPristine();
                $scope.order.form.search_address_delivery.$setPristine();
              };

              // mock advance payment
              $scope.cart.field_amount_advance_payment = $scope.cart.field_total_amount * 0.5;

              $scope.user = $profile.info;

              $scope.advancePayment = $filter('translate')('order.advancePayment');

              $scope.couponsLabels = {
                placeholder: $filter('translate')('order.couponPlaceholder'),
                button: $filter('translate')('order.couponButton')
              };

              $scope.deliveryOptions = [
                { text: $filter('translate')('form.yes'), value: true },
                { text: $filter('translate')('form.no'), value: false }
              ];

              $scope.configPayment = $rootScope.config.site.payment_modes_info;
              $scope.paymentDescription = function(value) {
                return lodash.chain($scope.paymentOptions).find({ value: value }).value().description;
              };

              $scope.order = {
                form: null,
                card: {
                  name: null,
                  number: null,
                  month: null,
                  months: [],
                  year: null,
                  years: [],
                  code: null
                },
                registerType: '',
                pending: false,
                paymentChoice: $scope.paymentOptions[0].value,
                deliveryChoice: !$profile.delivery.addressDelivery /* choice may have been made in order.user step */,
                delivery: {
                  address: $profile.info.field_adresse,
                  postal_code: $profile.info.field_cp,
                  city: $profile.info.field_ville,
                  country: findCountryCode($profile.info.field_pays)
                },
                internships: [],
                products: [],
                field_total_amount: 0,
                deliveryTime: 0,
                member_is_blocked: $profile.info.field_blocked
              };

              // TODO : create a credit card directive to avoid duplicate code
              var value = null;
              var text = null;
              var months = moment.months();
              for (var m = 1; m <= 12; m++) {
                value = (m <= 9 ? '0' : '') + m;
                text = months[m - 1];
                $scope.order.card.months.push({ value: value, text: text });
              }

              var year = new Date().getFullYear();
              for (var y = 0; y <= 6; y++) {
                text = year + y;
                value = (text + '').substr(-2);
                $scope.order.card.years.push({ value: value, text: text });
              }

              $scope.$watchCollection('order.search_addressDelivery', function(value) {
                if (value && value.address_components) {
                  var formated = tools.formatGAddress(value);
                  if (formated.address) {
                    $scope.order.delivery.address = formated.address;
                    $scope.order.delivery.postal_code = formated.postal_code;
                    $scope.order.delivery.city = formated.city;
                    $scope.order.delivery.country = findCountryCode(formated.country);
                  }
                }
              });

              $scope.scrolltoForm = function() {
                var element = angular.element(document.getElementById('orderForm'));
                $document.scrollToElement(element, 30, 250);
              };

              /* submit handler */
              $scope.register = function(registerType) {

                if (!$scope.order.pending && $scope.order.form.$valid) {
                  $scope.order.registerType = registerType;
                    $scope.scrolltoForm();
                  $scope.order.pending = true;
                  //$scope.loading = true;
                  // $scope.loadingExit = true;
                  var mode = $scope.order.paymentChoice;
                  $cart
                    .getMpiValues($scope.order, $scope.config.caution)
                    .then(function(response) {
                        //TODO: Do it better.. like with something that is Angular-y.. I'm so sorry....
                        $scope.order.mpi_values = response.mpiValues;
                        $scope.order.mpi_values.url_to_call = response.URLToCall;
                        $cookies.put('mpi_session', $scope.order.mpi_values.idSession);
                        $scope.order.mpi = undefined;
                        $scope.order.form = undefined;
                        $window.localStorage.setItem('order', angular.toJson($scope.order));
                        $cart.save();
                        // update of the values of the form via scope isn't done before we submit the form. need to do it by hand
                        var $mpi_form =  angular.element(document.querySelector('#mpi_form'))[0];
                        $mpi_form[0].value = $scope.order.mpi_values.idMerchant;
                        $mpi_form[1].value = $scope.order.mpi_values.idSession;
                        $mpi_form[2].value = $scope.order.mpi_values.amount;
                        $mpi_form[3].value = $scope.order.mpi_values.currency;
                        $mpi_form[4].value = $scope.order.mpi_values.CCNumber;
                        $mpi_form[5].value = $scope.order.mpi_values.CCExpDate;
                        $mpi_form[6].value = $scope.order.mpi_values.CVVCode;
                        $mpi_form[7].value = $scope.order.mpi_values.URLRetour;
                        $mpi_form[8].value = $scope.order.mpi_values.URLHttpDirect;
                        $mpi_form[9].value = $scope.order.mpi_values.email;
                        $mpi_form[10].value = $scope.order.mpi_values.firstName;
                        $mpi_form[11].value = $scope.order.mpi_values.lastName;
                        $mpi_form[12].value = $scope.order.mpi_values.address1;
                        $mpi_form[13].value = $scope.order.mpi_values.address2;
                        $mpi_form[14].value = $scope.order.mpi_values.zipCode;
                        $mpi_form[15].value = $scope.order.mpi_values.city;
                        $mpi_form[16].value = $scope.order.mpi_values.countryCode;
                        $mpi_form[17].value = $scope.order.mpi_values.totalQuantity;
                        $mpi_form.action = response.URLToCall;
                        $mpi_form.submit();
                    })
                    .catch(function(error) {
                      //$scope.loading = false;
                      $scope.loadingExit = false;
                      $scope.order.pending = false;
                      // test specific catch for unsuccessful paybox capture
                      // display message warning then go to confirmation page with data from paybox payment
                      if (error.message) {
                        var text = error.message === 'Paybox capture error'
                          ? 'Le paiement de votre caution a été refusé.'
                          : error.message;

                        swal({
                          title: 'Une erreur est survenue',
                          text: text,
                          icon: 'error'
                        }).then(function() {
                          $state.go('order.confirmation', { order: error.data.sfid, mode: mode });
                        });
                      }
                    });
                } else {
                  // console.warn('order is pending or form is invalid');
                  $scope.scrolltoForm();
                }
                // $scope.order.registerType = ''; // reset register type
              };

              /* booking option handler */
              $scope.booking = function() {
                if (!$scope.order.pending && $scope.order.approval) {
                  $scope.scrolltoForm();
                  // can book only if terms of use are approved and form is not processing
                  $scope.order.pending = true;
                  //$scope.loading = true;
                  $scope.loadingExit = true;

                  drupal
                    .bookingCommand($scope.order)
                    .then(function(response) {
                      return $scope.cartResponseHandler(response, 'booking');
                    })
                    .catch(function(error) {
                      // no specific error handling
                      //$scope.loading = false;
                      $scope.loadingExit = false;
                      $scope.order.pending = false;
                      $scope.scrolltoForm();
                    });
                }
              };

              // sf cart registering error handler
              $scope.cartResponseHandler = function(data, register) {
                $scope.order.pending = false;
                $scope.loadingExit = false;

                if (data.codereponse === '00000') {
                  $state.go('order.confirmation', { order: data.sfid, mode: register }); // TMP: mocked redirection
                  $scope.ignoreWatch = false;
                } else {
                  $scope.ignoreWatch = false;
                  $state.mpi_values = undefined;
                  $scope.order.card.number = undefined;
                  $scope.order.card.month = undefined;
                  $scope.order.card.year = undefined;
                  $scope.order.card.code = undefined;
                  // Failure.
                  swal({
                    title: 'Une erreur est survenue',
                    text: 'Votre paiement a été refusé pour la raison suivante :\n' + data.commentaire,
                    icon: 'error'
                  });
                }
              };
            }
          ],
          templateUrl: 'src/views/order/order_payment.html'
        }
      }
    });
  }
]);
